module.exports = __webpack_public_path__ + "img/craggy_coat.357f1233.png";